import React from 'react'
import styles from './HowItWorksSection.module.css'

const HowItWorksSection = ({ isActive }) => {
  const steps = [
    {
      number: '1',
      title: '주제선택',
      description: 'HTP, DAP, PITR 중에서 오늘의 그림 주제를 고릅니다.',
      icon: '📝',
      color: '#8B5CF6'
    },
    {
      number: '2', 
      title: '그림 그리기',
      description: '여러가지 드로잉 도구로 자유롭게 표현하며 나만의 작품을 만듭니다.',
      icon: '🎨',
      color: '#06B6D4'
    },
    {
      number: '3',
      title: 'AI 분석',
      description: '색, 선, 배치에서 드러난 감정을 AI가 분석하고 맞춤 분석을 제공합니다.',
      icon: '🤖',
      color: '#10B981'
    },
    {
      number: '4',
      title: '성장 & 공유',
      description: '커뮤니티에서 소통하고, 치유 코스를 통해 단계적으로 성장합니다.',
      icon: '🏆',
      color: '#F59E0B'
    }
  ]

  return (
    <div className={`${styles.howItWorksSection} ${isActive ? styles.active : ''}`}>
      <div className={styles.container}>
        <header className={styles.header}>
          <h2 className={styles.title}>쉽게 이용하고, 깊이 즐기다.</h2>
          <p className={styles.subtitle}>간단한 4단계로 시작하는 마음 치유 여정</p>
        </header>

        <div className={styles.stepsContainer}>
          <div className={styles.steps}>
            {steps.map((step, index) => (
              <div 
                key={index}
                className={styles.step}
                style={{ 
                  '--step-color': step.color,
                  '--animation-delay': `${index * 0.2}s`
                }}
              >
                <div className={styles.stepNumber}>
                  {step.number}
                </div>
                
                <div className={styles.stepIcon}>
                  {step.icon}
                </div>
                
                <div className={styles.stepContent}>
                  <h3 className={styles.stepTitle}>{step.title}</h3>
                  <p className={styles.stepDescription}>{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.ctaSection}>
          <button className={styles.startBtn}
          onClick={() => {
            window.location.href = '/signup';
          }}
          >
            <i className="fas fa-paint-brush"></i>
            지금 바로 가입하기
          </button>
          <p className={styles.ctaNote}>
            ⭐ 지금 바로 시작해보세요!
          </p>
        </div>
      </div>
    </div>
  )
}

export default HowItWorksSection